import React, { useState,useEffect , useContext} from 'react';
import './payment.css'
import Sidebar from '../../components/Sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch, faRefresh, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import TopBar from '../../components/topbar'

import moment from 'moment'
import JisAlert from '../../components/jisalert'

function Payment() {

    const { profile } = useContext(ShareContext);
    const [search, setSearch] = useState('')
    const url= `${Constants.apiUrl}/gazette/paymenthistory/${profile.username}`;
    const[pays, setPays]= useState([]);
    const [filterSearch, setFilterSearch]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [startdate, setStartDate]=useState(new Date());
    const [enddate, setEndDate]=useState(new Date());

    useEffect(() => {     
        onLoad();
        
     
  }, [])

  const onLoad= async()=>{
    //for account registration
    console.log(`the calling url ${url}`);
    try {
        setIsLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const data = await resp.json();
      
        setIsLoading(false);
        console.log(data);
        if (data.code === 0) {
            setPays(data.pays);
            setFilterSearch(data.pays);
           
        }else {    
            alert(data.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        
      }
}


    const navigate = useNavigate();



    const onSearch=(e)=>{
        var s=e.target.value;
        setSearch(s);
        const fs = pays.filter(item => {
        const searchValue = item.reference.toLowerCase().includes(s.toLowerCase());
        return searchValue
        });
        setFilterSearch(fs);
    }
    const onReset=()=>{
        setSearch('');
        setFilterSearch(pays);
     }

     const onSearchRange=async()=>{
        console.log(`the calling url ${url}`);
        var rstart= moment(startdate).format("YYYY-MM-DD");
        var rend=moment(enddate).format("YYYY-MM-DD");
        var urls=`${Constants.apiUrl}/gazette/paymenthistory/${profile.username}/${rstart}/${rend}`;
        try {
            setIsLoading(true);
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
          
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setPays(data.pays);
                setFilterSearch(data.pays);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
     }


  return (
    <div className='payment-records'>
        <Sidebar />
        <div className="body">
        <TopBar title="Home/ Payment History" />
            <div className="container">
            <div className="search-table">
                <div className="form-inp">
              
                    <input type="text" placeholder='Filter by Reference' id='search-title' value={search} onChange={(e)=> onSearch(e)}/>
                </div>
                
                <div className="reset-fields" onClick={onReset}>
                    <p>Reset Fields</p>
                    <FontAwesomeIcon icon={faRefresh} />
                </div>
            </div>
            <div>
               From Date <input type="date" value={startdate} onChange={(e)=>setStartDate(e.target.value)} placeholder='Start Date' className='regularInput' /> -  
               To Date <input type="date" placeholder='End  Date' value={enddate} className='regularInput' onChange={(e)=>setEndDate(e.target.value)} />  
               <button className='red'  onClick={onSearchRange}>Search <FontAwesomeIcon icon={faSearch} /></button></div>
                <div className="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Reference</th>
                                <th>Payment Type</th>
                                <th>Amount (₦)</th>
                                <th>Payment Date</th>
                                <th>Note</th>
                             {profile.role=='LegalCounsel' && <th>Receipt</th>}   
                               
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filterSearch.map((rec, idx) => {return(
                            <tr key={idx}>
                                <td>{rec.reference}</td>
                                <td>{rec.type==4?'Search':'Affidavit'}</td>
                                <td>{Constants.formatCurrency(rec.amount) }</td>
                                <td>{moment(rec.dateCreated).format("dddd, MMMM Do YYYY, h:mm a") }</td>
                                <td>{rec.note}</td>
                               
                              {<td className='view-affbtn'>
                                      <Link to={`/payment-receipt/${rec.reference}`} target='_blank'><button type='button' className='red' target="_blank"> Receipt <FontAwesomeIcon icon={faAngleRight} /></button></Link>
                                        
                                       
                                        </td>}  
                    
                               
                            </tr>
                                )})
                            }
                        </tbody>
                    </table>
                </div>
            </div>
           
            <BackLoader open={isLoading}  />
        </div>
    </div>
  )
}

export default Payment